module.exports = __webpack_public_path__ + "static/founder-autosave-646e86b01053a99ecce0991fe1b6656f.svg";